import React from 'react'

const KotlinBasics = () => {
  return (
    <div>
        {/* collapseSixtyTwo */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSixtyTwo">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSixtyTwo" aria-expanded="false" aria-controls="collapseSixtyTwo">
                    Kotlin Basics <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSixtyTwo" className="accordion-collapse collapse" aria-labelledby="headingSixtyTwo" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>Print, Toast, and Comments</strong><br/>
                    <ul>
                        <li>Console</li>
                        <li>Printing values</li>
                        <li>Exposing to the UI</li>
                    </ul>
                    <strong>Variables and Primitives</strong><br/>
                    <ul>
                        <li>Var</li>
                        <li>Val</li>
                        <li>Int, Float, Boolean, Char, String</li>
                    </ul>
                    <strong>Operators</strong><br/>
                    <ul>
                        <li>Arithmetic</li>
                        <li>Increment</li>
                        <li>Augmented increment</li>
                    </ul>
                    <strong>Control Flow</strong><br/>
                    <ul>
                        <li>If else if</li>
                        <li>When</li>
                        <li>Ternary</li>
                        <li>Do While Loop</li>
                        <li>While Loop</li>
                        <li>For Loop</li>
                    </ul>
                    <strong>Collections</strong><br/>
                    <ul>
                        <li>Lists</li>
                        <li>Arrays</li>
                        <li>Maps</li>
                        <li>Iteration</li>
                    </ul>
                    <strong>Dice Generator</strong><br/>
                    <ul>
                        <li>An example to bring everything together</li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
  )
}

export default KotlinBasics